
import {defineComponent} from 'vue';

export default defineComponent({
    name: 'CommercialTag',
    props: {
        label: {
            type: String,
            required: true
        },
        version: {
            type: String,
            required: true
        },
        isInverse: {
            type: Boolean,
            required: false,
            default: false
        },
        isSmall: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        className(): string {
            return `ob1-tag-${this.version}`;
        },
        classes(): string[] {
            let classes = [this.className];
            if (this.isInverse) {
                classes.push('ob1-tag-inverse');
            } else if (this.isSmall) {
                classes.push('ob1-tag-small');
            }
            return classes;
        }
    }
});
